import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Output } from '@angular/core';
import { AgentscriptService_updated } from '../services/agent-script-service/agent-script-service';

@Component({
  selector: 'app-recenttickets',
  templateUrl: './recenttickets.component.html',
  styleUrls: ['./recenttickets.component.scss'],
})
export class RecentticketsComponent {
  @Output() componentSelection = new EventEmitter<any>();

  ngOnInit(): void {
    console.log('RecentticketsComponent');
    this.agentrecentaccess();
    // this.categorizeItems();
  }

  constructor(
    private http: HttpClient,
    private agentscriptservice: AgentscriptService_updated
  ) {}

  agentrecentaccess() {
    this.agentscriptservice.agentrecentaccess();
  }

  openintab(item: any) {
    console.log(item);
    var department;
    var imageSrc;
    var tabname;
    var type;
    switch (item.entityName) {
      case 'Incident':
        department = item.department;
        imageSrc = '../../../assets/images/Profile.svg';
        tabname = item.name;
        type= 'object';
        break;

      case 'Contact':
        department = item.entityName;
        imageSrc = '../../../assets/images/Profile.svg';
        tabname = item.name+ '-'+item.id
        type= 'object';
        break;

      case 'Answer':
        department = item.entityName;
        imageSrc = '../../../assets/images/existinganswer.svg';
        // tabname = item.name + '-'+item.id
        tabname = "Answer" + '-'+item.id
        type= 'answer';
        break;
    }

    this.componentSelection.emit({
      id: item.id,
      name: tabname,
      type: type,
      entityName: item.entityName,
      department: department,
      src:imageSrc
    });
  }

  
  getImageUrl(item: any) {
    // Logic to get image URL based on item.entityName
    return item.entityName === 'Incident'
      ? '../../../assets/images/existingservicerequest.svg'
      : item.entityName === 'Contact'
      ? '../../../assets/images/Profile.svg'
      : item.entityName === 'Answer'
      ? '../../../assets/images/existinganswer.svg'
      : '';
  }

  // transform(value: any) {
  //   // return value.replace(/[^\w\s]/gi, '');
    
  //   return value.replace(/<[^>]+>/g, '')
  // }
  
  transform(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
  
    value = String(value);
  
    // Remove escaped quotes and normal quotes
    value = value.replace(/\\"/g, '').replace(/"/g, '');
  
    // Convert HTML to plain text
    const div = document.createElement('div');
    div.innerHTML = value;
  
    let text = div.textContent || div.innerText || '';
  
    // Replace non-breaking spaces
    text = text.replace(/\u00A0/g, ' ');
  
    // Remove &nbsp; if it remains
    text = text.replace(/&nbsp;/gi, ' ');
  
    // Remove extra spaces/new lines
    return text.replace(/\s+/g, ' ').trim();
  }
}
